@if (toggle()) {
  <article @fadeInOut class="mini-alert">
    <p class="text--sm text--medium">{{ message() }}</p>
    <fa-icon [icon]="circleMark" class="clickable" (click)="forceCloseAlert()"></fa-icon>
  </article>
}
